import React, { useState, useEffect, useMemo } from "react";
import { Button } from "react-bootstrap";
import Cookies from "js-cookie";
import moment from "moment";
import qs from "qs";

import {
  AxiosCustomGet,
  AxiosCustomPost,
  AxiosCustomPut,
} from "../../../../components/axios/AxiosCustom";
import Config from "../../../../components/axios/Config";
import Title from "../../../../components/common/Title/Title";
import Breadcrumb from "../../../../components/common/Breadcrumb/Breadcrumb";
import TextInput from "../../../../components/common/TextInput/TextInput";
import MultipleSelect from "../../../../components/common/MultipleSelect/MultipleSelect";
import CustomDatePicker from "../../../../components/common/DatePicker/CustomDatePicker";
import FilterButton from "../../../../components/common/Button/FilterButton";
import CustomTable from "../../../../components/common/Table/CustomTable";
import ExportButton from "../../components/ExportButton";
import ChangeStatusDialog from "./components/ChangeStatusDialog";
import ProcessBiddingDialog from "./components/ProcessBiddingDialog";
import SwalToast from "../../../../components/helpers/SwalToast";

import { convertCategory, convertTenor } from "../../helpers";
import { convertFailedRedeem, convertReportStatus } from "../helpers";

import {
  failedRedeemInitFilterInput,
  renderFailedRedeemColumns,
  failedReedemStatusList,
  changeStatusInitData,
  processBiddingInitData,
} from "../constants";
import {
  initCategoryAndTenor,
  initPaymentAndTenorType,
  paymentTypeList,
  tenorTypeList,
} from "../../constants";

import "../../styles.css";
import PreviewImage from "../../../../components/common/PreviewImage/PreviewImage";
import { AuthorizationList } from "../../../../components/template/authorization/Authorization";

const FailedRedeem = () => {
  const [pageSizeValue, setPageSizeValue] = useState(10);
  const [searchNameValue, setSearchNameValue] = useState("");

  const [filterInput, setFilterInput] = useState(failedRedeemInitFilterInput);
  const [categoryList, setCategoryList] = useState([]);
  const [failedRedeemList, setFailedRedeemList] = useState([]);
  const [statusList, setStatusList] = useState(failedReedemStatusList);
  const [loading, setLoading] = useState(false);
  const [isChangingType, setIsChangingType] = useState(false);
  const [isProcessBiddingDialogOpen, setIsProcessBiddingDialogOpen] =
    useState(false);
  const [isChangeStatusDialogOpen, setIsChangeStatusDialogOpen] =
    useState(false);
  const [tablePagination, setTablePagination] = useState({});

  const [selectedCategory, setSelectedCategory] =
    useState(initCategoryAndTenor);
  const [selectedPaymentType, setSelectedPaymentType] = useState(
    initPaymentAndTenorType
  );
  const [selectedTenorType, setSelectedTenorType] = useState(
    initPaymentAndTenorType
  );
  const [selectedTenor, setSelectedTenor] = useState(initCategoryAndTenor);
  const [dateValue, setDateValue] = useState([]);
  const [selectedID, setSelectedID] = useState("");
  const [errors, setErrors] = useState({});
  const [changeStatusData, setChangeStatusData] =
    useState(changeStatusInitData);
  const [processBiddingData, setProcessBiddingData] = useState(
    processBiddingInitData
  );
  const [documentImg, setDocumentImg] = useState([]);
  const [imgLink, setImgLink] = useState("");
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [tenorList, setTenorList] = useState([]);

  const getCategory = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}product-categories`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setCategoryList(convertCategory(response.data.data.items));
      }
    );
  };

  const getTenorList = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}tenors`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setTenorList(convertTenor(response.data.data));
      }
    );
  };

  const getFailedRedeemList = () => {
    setLoading(true);
    const data = {
      query: filterInput.searchName,
      product_category: filterInput.category,
      payment_type: filterInput.paymentType,
      tenor_type: filterInput.tenorType,
      tenor: filterInput.tenor,
      date_start: filterInput.failedRedeemStartDate,
      date_end: filterInput.failedRedeemEndDate,
      page: filterInput.page,
      size: parseInt(filterInput.pageSize),
      status: filterInput.status,
      sorting_field: filterInput.sortingField,
      sorting_order: filterInput.sortingOrder,
    };

    let url = `${process.env.REACT_APP_BASE_API_URL}report/failed-redeem`;
    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        },
        data,
        (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        }
      ),
      (response) => {
        const data = response?.data?.data;
        setLoading(false);

        setFailedRedeemList(
          convertFailedRedeem(data?.items?.failed_redeem, handleOpenPreview)
        );

        if (!isChangingType) {
          setStatusList(
            convertReportStatus(
              failedReedemStatusList,
              data?.items?.transaction_type_count,
              filterInput.status
            )
          );
        }

        setTablePagination({
          current: data?.page,
          pageSize: data?.per_page,
          total: data?.total_item,
        });

        setIsChangingType(false);
      },
      (error) => {
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: `Gagal mengambil data transaksi: ${error?.response?.data?.error?.message}`,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const dataPdf = useMemo(() => {
    const temp = failedRedeemList.map(({ document, ...item }) => ({
      ...item,
      offerLink: item?.offerLink?.props?.children || "-",
    }));
    return temp;
  }, [failedRedeemList]);

  const handleEnter =
    (type = "enter") =>
    (event) => {
      const { name, value } = event.target;
      if (event.keyCode === 13 || type === "blur") {
        if (name === "pageSize" && value === "") {
          setPageSizeValue(10);
        }
        setFilterInput((prev) => ({
          ...prev,
          [name]: name === "pageSize" && value === "" ? 10 : value,
          page: 1,
        }));
      }
    };

  const handleSelectChange = (field, data) => {
    if (field === "category") {
      setSelectedCategory({
        value: data.value,
        label: data.label,
      });
    } else if (field === "paymentType") {
      setSelectedPaymentType({
        value: data.value,
        label: data.label,
      });
    } else if (field === "tenorType") {
      setSelectedTenorType({
        value: data.value,
        label: data.label,
      });
    } else if (field === "tenor") {
      setSelectedTenor({
        value: data.value,
        label: data.label,
      });
    }

    setFilterInput((prev) => ({
      ...prev,
      [field]: data.value,
      page: 1,
    }));
  };

  const handleDateChange = (event) => {
    const startDate = moment(event?.[0]?._d).startOf("day");
    const endDate = moment(event?.[1]?._d).startOf("day");
    setDateValue(event ? [startDate, endDate] : null);
    setFilterInput((prev) => ({
      ...prev,
      transactionStartDate: event ? new Date(startDate) : null,
      transactionEndDate: event ? new Date(endDate) : null,
      page: 1,
    }));
  };

  const handleProcessBiddingButtonClick = (failedRedeemID) => {
    setSelectedID(failedRedeemID);
    setIsProcessBiddingDialogOpen(true);
  };

  const handleChangeStatusButtonClick = (failedRedeemID) => {
    setSelectedID(failedRedeemID);
    setIsChangeStatusDialogOpen(true);
  };

  const handleReset = () => {
    setPageSizeValue(10);
    setSearchNameValue("");
    setSelectedCategory(initCategoryAndTenor);
    setSelectedTenor(initCategoryAndTenor);
    setSelectedTenorType(initPaymentAndTenorType);
    setSelectedPaymentType(initPaymentAndTenorType);
    setDateValue([]);

    setFilterInput(failedRedeemInitFilterInput);
  };

  const handleStatusChange = (e) => {
    setIsChangingType(true);
    const currentValue = e.target.value;

    setStatusList((prev) => {
      const temp = [...prev];
      temp.map((status) => {
        status.active = currentValue === status.value ? true : false;
        return status;
      });
      return temp;
    });

    setFilterInput((prev) => ({
      ...prev,
      status: currentValue,
      page: 1,
    }));
  };

  const handleTableChange = (pagination, _, sorter) => {
    setFilterInput((prev) => ({
      ...prev,
      page: pagination.current,
      size: parseInt(pagination.pageSize),
      sortingField: sorter?.column?.backend_key || null,
      sortingOrder:
        sorter?.order === "ascend"
          ? "ASC"
          : sorter?.order === "descend"
          ? "DESC"
          : null,
    }));
  };

  const handleTextInputChange = (event) => {
    const { name, value } = event.target;
    if (name === "pageSize") {
      setPageSizeValue(value);
    } else if (name === "searchName") {
      setSearchNameValue(value);
    }
  };

  const handleDialogInputChange = (field, value, from) => {
    if (from === "processBidding") {
      setProcessBiddingData((prev) => ({
        ...prev,
        [field]: value,
      }));

      if (errors[field]) {
        setErrors((prev) => ({
          ...prev,
          [field]: null,
        }));
      }
    } else if (from === "changeStatus") {
      setChangeStatusData((prev) => ({
        ...prev,
        [field]: value,
      }));

      if (errors[field]) {
        setErrors((prev) => ({
          ...prev,
          [field]: null,
        }));
      }
    }
  };

  const handleOpenPreview = (src) => () => {
    setImgLink(src);
    setIsPreviewOpen(true);
  };

  const handleUploadImage = (type) => (options) => {
    const { onSuccess, onError, file } = options;

    const fmData = new FormData();
    fmData.append("file", file);

    let url = `${process.env.REACT_APP_BASE_API_URL}upload-image`;
    AxiosCustomPost(
      url,
      fmData,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
        "content-type": "multipart/form-data",
      }),
      (response) => {
        onSuccess(response.data.data, file);
        setChangeStatusData((prev) => ({
          ...prev,
          document:
            type === "document"
              ? response.data.data.object_path
              : prev.document,
        }));
      },
      (error) => {
        onError({ error });
      }
    );
  };

  const handleImageChange =
    (type) =>
    ({ fileList }) => {
      let tempFileList = [...fileList];
      tempFileList = tempFileList.slice(-1);

      tempFileList = tempFileList.map((file) => {
        if (file.response) {
          file.url = file.response.url;
        }
        return file;
      });
      if (type === "document") {
        setDocumentImg(tempFileList);
      }
      if (errors[type]) {
        setErrors((prev) => ({
          ...prev,
          [type]: null,
        }));
      }
    };

  const handleExport = (type) => (e) => {
    if (type === "excel") {
      handleExportExcel();
    }
  };

  const handleExportExcel = () => {
    const data = {
      query: filterInput.searchName,
      product_category: filterInput.category,
      payment_type: filterInput.paymentType,
      tenor_type: filterInput.tenorType,
      tenor: filterInput.tenor,
      date_start: filterInput.failedRedeemStartDate,
      date_end: filterInput.failedRedeemEndDate,
      page: filterInput.page,
      size: parseInt(filterInput.pageSize),
      status: filterInput.status,
      sorting_field: filterInput.sortingField,
      sorting_order: filterInput.sortingOrder,
    };

    let url = `${process.env.REACT_APP_BASE_API_URL}report/failed-redeem/excel`;
    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
          "content-type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        data,
        (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        },
        "blob"
      ),
      (response) => {
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
        });
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "laporan_gagal_tebus.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
      (error) => {
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: `Gagal export data menjadi excel: ${error?.response?.data?.error?.message}`,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const handleCancel = () => {
    setIsProcessBiddingDialogOpen(false);
    setIsChangeStatusDialogOpen(false);

    if (errors) {
      setErrors({});
    }
  };

  const handleProcessBidding = () => {
    const newErrors = validate(processBiddingData, "processBidding");

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      const data = {
        auction_destination: processBiddingData.destination,
        offer_link: processBiddingData.offeringLink,
      };

      const url = `${process.env.REACT_APP_BASE_API_URL}report/failed-redeem/proceed/${selectedID}`;

      AxiosCustomPut(
        url,
        data,
        Config({
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        }),
        () => {
          SwalToast.fire({
            icon: "success",
            title: "Berhasil melakukan proses penawaran",
          });
        },
        (error) => {
          if (error.response) {
            SwalToast.fire({
              icon: "error",
              title: `Gagal melakukan proses penawaran: ${error.response.data.error.message}`,
            });
          } else {
            SwalToast.fire({
              icon: "error",
              title: "Whoops, something went wrong",
            });
          }
        },
        () => {
          setIsProcessBiddingDialogOpen(false);
          setProcessBiddingData(processBiddingInitData);
          getFailedRedeemList();
        }
      );
    }
  };

  const handleChangeStatus = () => {
    const newErrors = validate(changeStatusData, "changeStatus");

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      const data = {
        auction_destination: changeStatusData.status,
        sold_amount: parseInt(changeStatusData.sellPrice),
        offer_link: changeStatusData.offeringLink,
        delivery_order: changeStatusData.document,
        auction_other_fee: parseInt(changeStatusData.otherFee),
        description: changeStatusData.description,
      };

      const url = `${process.env.REACT_APP_BASE_API_URL}report/failed-redeem/complete/${selectedID}`;

      AxiosCustomPut(
        url,
        data,
        Config({
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        }),
        () => {
          SwalToast.fire({
            icon: "success",
            title: "Berhasil mengubah status",
          });
        },
        (error) => {
          if (error.response) {
            SwalToast.fire({
              icon: "error",
              title: `Gagal mengubah status: ${error.response.data.error.message}`,
            });
          } else {
            SwalToast.fire({
              icon: "error",
              title: "Whoops, something went wrong",
            });
          }
        },
        () => {
          setIsChangeStatusDialogOpen(false);
          setChangeStatusData(changeStatusInitData);
          getFailedRedeemList();
        }
      );
    }
  };

  const validate = (data, from) => {
    const newErrors = {};

    if (from === "changeStatus") {
      if (!data.status || data.status === "") {
        newErrors.status = "Status harus dipilih";
      }
      if (!data.sellPrice || data.sellPrice === "") {
        newErrors.sellPrice = "Harga terjual tidak boleh kosong";
      }
      if (!data.offeringLink || data.offeringLink === "") {
        newErrors.offeringLink = "Link penawaran tidak boleh kosong";
      }
      if (!data.otherFee || data.otherFee === "") {
        newErrors.otherFee = "Biaya Lain-lain tidak boleh kosong";
      }
      if (!data.description || data.description === "") {
        newErrors.description = "Keterangan tidak boleh kosong";
      }
      if (data.status === "Mitra" && (!data.document || data.document === "")) {
        newErrors.document = "Surat jalan harus diupload";
      }
    } else if (from === "processBidding") {
      if (!data.destination || data.destination === "") {
        newErrors.destination = "Tujuan lelang harus dipilih";
      }
      if (!data.offeringLink || data.offeringLink === "") {
        newErrors.offeringLink = "Link penawaran tidak boleh kosong";
      }
    }
    return newErrors;
  };

  const getMonthly = () => {
    let startOfMonth = moment().startOf("month");
    let endOfMonth = moment();

    setDateValue([startOfMonth, endOfMonth]);
    setFilterInput((prev) => ({
      ...prev,
      transactionStartDate: new Date(startOfMonth),
      transactionEndDate: new Date(endOfMonth),
    }));
  };

  useEffect(() => {
    getFailedRedeemList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterInput]);

  useEffect(() => {
    getCategory();
    getTenorList();
    getMonthly();
  }, []);

  return (
    <div>
      <div className="px-3">
        <div className="py-4 d-flex flex-column" style={{ fontSize: "13px" }}>
          <Title text={"Gagal Tebus"} />
          <Breadcrumb current={"Gagal Tebus"} />
        </div>

        <div className="d-flex justify-content-between filter-bar">
          <TextInput
            id={"pageSize"}
            label={"Tampilkan"}
            width={"7%"}
            handleEnter={handleEnter}
            handleChange={handleTextInputChange}
            value={pageSizeValue}
          />
          <TextInput
            id={"searchName"}
            label={"Kode Gadai / No. Kwitansi / Nama Nasabah"}
            width={"30%"}
            placeholder={"Cari.."}
            handleEnter={handleEnter}
            handleChange={handleTextInputChange}
            value={searchNameValue}
          />
          <MultipleSelect
            id={"category"}
            label={"Kategori Produk"}
            isSearchable={true}
            onSelectChange={handleSelectChange}
            options={categoryList}
            value={selectedCategory}
          />
          <MultipleSelect
            id={"paymentType"}
            label={"Jenis Pembayaran"}
            onSelectChange={handleSelectChange}
            options={paymentTypeList}
            value={selectedPaymentType}
          />
          <MultipleSelect
            id={"tenorType"}
            label={"Jenis Tenor"}
            options={tenorTypeList}
            onSelectChange={handleSelectChange}
            value={selectedTenorType}
          />
          <div className="filter-bar">
            <Button
              variant="link"
              className="btn-action btn-reset"
              onClick={handleReset}
            >
              Reset semua filter
            </Button>
          </div>
        </div>

        <div className="d-flex filter-bar-2">
          <MultipleSelect
            id={"tenor"}
            label={"Tenor"}
            onSelectChange={handleSelectChange}
            options={tenorList}
            value={selectedTenor}
          />
          <CustomDatePicker
            id={"failedRedeem"}
            label={"Tanggal Gagal Tebus"}
            isRangePicker
            width="20%"
            onInputChange={handleDateChange}
            value={dateValue}
          />
        </div>

        <div className="d-flex flex-row filter-bar-2 mt-2 mb-4">
          <div>
            <span style={{ fontSize: "15px" }}>Status:</span>
          </div>
          <div className="d-flex flex-wrap" style={{ gap: "10px" }}>
            {statusList.map((status) => {
              return (
                <FilterButton
                  data={status}
                  handleChange={handleStatusChange}
                  type="status"
                />
              );
            })}
          </div>
        </div>

        <CustomTable
          columns={renderFailedRedeemColumns(
            handleProcessBiddingButtonClick,
            handleChangeStatusButtonClick
          )}
          data={failedRedeemList}
          loading={loading}
          handleTableChange={handleTableChange}
          pagination={tablePagination}
          scrollX={1500}
        />

        <div className="filter-bar-2 d-flex" style={{ marginTop: "2rem" }}>
          <ExportButton
            handleExport={handleExport}
            pathname="/report/failed-redeem/export"
            data={dataPdf}
            from="report"
            columns={renderFailedRedeemColumns(null, null, false)}
          />
        </div>
      </div>
      <ChangeStatusDialog
        visible={isChangeStatusDialogOpen}
        handleCancel={handleCancel}
        handleSave={handleChangeStatus}
        handleSavePermissions={AuthorizationList.update_report_failed_gadai}
        onInputChange={handleDialogInputChange}
        errors={errors}
        data={changeStatusData}
        onImageChange={handleImageChange}
        handleUploadImage={handleUploadImage}
        documentImg={documentImg}
      />
      <ProcessBiddingDialog
        visible={isProcessBiddingDialogOpen}
        handleCancel={handleCancel}
        handleSave={handleProcessBidding}
        handleSavePermissions={AuthorizationList.update_report_failed_gadai}
        onInputChange={handleDialogInputChange}
        errors={errors}
        data={processBiddingData}
      />

      <PreviewImage
        visible={isPreviewOpen}
        setVisible={setIsPreviewOpen}
        url={imgLink}
      />
    </div>
  );
};

export default FailedRedeem;
